<template>
	<div style="padding:8px;">
		<div style="padding:2px;">
			<el-tabs v-model="activeName" @tab-click="tabClick">
				<el-tab-pane label="攀中伊红" name="first">
					<baseView v-if="detailVisible1"></baseView>
				</el-tab-pane>
				<el-tab-pane label="二基地" name="second">
					<baseViewB v-if="detailVisible2"></baseViewB>
				</el-tab-pane>
				<el-tab-pane label="三基地" name="third">
					<baseViewC v-if="detailVisible3"></baseViewC>
				</el-tab-pane>
				<el-tab-pane label="四基地" name="fourth">
					<baseViewD v-if="detailVisible4"></baseViewD>
				</el-tab-pane>
				<el-tab-pane label="五基地" name="fifth">
					<baseViewE v-if="detailVisible5"></baseViewE>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div
			style="width:100%;margin-top: 10px; background-color: #efefef;text-align: center; height: 50px;line-height: 50px;border-top: 1px solid #ccc; margin-bottom: 2px;">
			2022 重庆市离离科技有限公司 备案 渝ICP备2020011628号-1
		</div>
	</div>
</template>

<script>
	export default {
		components: {
			baseView: () => import('./baseView.vue'),
			baseViewB: () => import('./baseViewB.vue'),
			baseViewC: () => import('./baseViewC.vue'),
			baseViewD: () => import('./baseViewD.vue'),
			baseViewE: () => import('./baseViewE.vue'),
		},
		data() {
			return {
				detailVisible1: true,
				detailVisible2: false,
				detailVisible3: false,
				detailVisible4: false,
				detailVisible5: false,
				activeName: 'first',
				form: {
					region: '',
					hzfs: '',
					hzyx: ''
				},
			};
		},
		methods: {
			onSubmit() {

			},
			tabClick(e) {
				this.detailVisible1 = this.detailVisible2 = this.detailVisible3 = this.detailVisible4 = this.detailVisible5 = false
				this.activeName = e.name
				switch (e.name) {
					case "first":
						this.detailVisible1 = true;
						break;
					case "second":
						this.detailVisible2 = true;
						break;
					case "third":
						this.detailVisible3 = true;
						break;
					case "fourth":
						this.detailVisible4 = true;
						break;
					case "fifth":
						this.detailVisible5 = true;
						break;
				}
			}
		},
		mounted() {

		}
	};
</script>

<style lang="less" scoped>

</style>